<div class="flex flex-column gap-3 scrollable">
  <div *ngFor="let license of licenses">
    <div class="p-3 border-2 border-round-xl surface-border flex flex-column">
      <span class="text-xl font-bold">{{ license.productName }}</span>
      <br />
      <div>
        <span class="text-color-secondary">{{ 'LABELS.MODULE_TYPE' | translate }}:</span>
        {{ license.swModule ? 'Software' : 'Hardware' }}
      </div>
      <div>
        <span class="text-color-secondary">{{ 'LABELS.LICENSE_KEY' | translate }}:</span>
        {{ license.licenseKey }}
      </div>
      <div *ngIf="licenseBundle">
        <span class="text-color-secondary">{{ 'LABELS.BUNDLE_LICENSE_KEY' | translate }}:</span>
        {{ licenseBundle.licenseKey }}
      </div>
      <div>
        <span class="text-color-secondary">{{ 'LABELS.LICENSE_TYPE' | translate }}:</span>
        {{ 'DB.LICENSE_TYPES.CODE.' + license.licenseType.code | translate }}
      </div>
      <div *ngIf="license.licenseDurationTime">
        <span class="text-color-secondary">{{ 'LABELS.LICENSE_DURATION' | translate }}:</span>
        {{ license.licenseDurationTime + ' ' + ('LABELS.DAYS' | translate) }}
      </div>
      <div *ngIf="license.licenseDurationUnits">
        <span class="text-color-secondary">{{ 'LABELS.LICENSE_DURATION' | translate }}:</span>
        {{ license.licenseDurationUnits + ' ' + ('LABELS.UNITS' | translate) }}
      </div>
      <!-- 
      NON SONO PRESENTI NELLA RISPOSTA DAL SERVER
      <div *ngIf="license.usedUnits">
        <span class="text-color-secondary">{{ 'LABELS.USED_UNITS' | translate }}:</span>
        {{ license.usedUnits }}
      </div>
      <div *ngIf="license.validFrom">
        <span class="text-color-secondary">{{ 'LABELS.VALID_FROM' | translate }}:</span>
        {{ license.validFrom | formatDate: 'P' : true }}
      </div> -->
      <div>
        <span class="text-color-secondary">{{ 'LABELS.ACTIVATION_TIME' | translate }}:</span>
        {{ license.activationTime | formatDate: 'P' : true }}
      </div>
      <div *ngIf="license.expirationTime">
        <span class="text-color-secondary">{{ 'LABELS.EXPIRATION_TIME' | translate }}:</span>
        {{ license.expirationTime | formatDate: 'P' : true }}
      </div>
      <div *ngIf="license.maxWorkstations">
        <span class="text-color-secondary">{{ 'LABELS.MAX_WORKSTATIONS' | translate }}:</span>
        {{ license.maxWorkstations }}
      </div>
      <div *ngIf="licenseBundle">
        <span class="text-color-secondary">{{ 'LABELS.OFFLINE_LICENSE_KEY_EXPIRATION_TIME' | translate }}:</span>
        {{ offlineLicenseKeyExpirationTime | formatDate: 'P' : true }}
      </div>

      <div class="mt-3">
        <app-license-key-copyable [offlineLicenseKey]="offlineLicenseKey" [showRenewOfflineLicenseKeyButton]="false"></app-license-key-copyable>
      </div>
    </div>
  </div>
</div>

<div class="mt-3 w-full flex justify-content-end gap-3">
  <button pButton [label]="'BUTTONS.CLOSE' | translate" (click)="ref.close()"></button>
</div>
